module.exports = __webpack_public_path__ + "img/preview_dy2.6e7ed897.png";